import { render, staticRenderFns } from "./CustomerCards.vue?vue&type=template&id=26d3d4d7&scoped=true&"
import script from "./CustomerCards.vue?vue&type=script&lang=js&"
export * from "./CustomerCards.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCards.vue?vue&type=style&index=0&id=26d3d4d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d3d4d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26d3d4d7')) {
      api.createRecord('26d3d4d7', component.options)
    } else {
      api.reload('26d3d4d7', component.options)
    }
    module.hot.accept("./CustomerCards.vue?vue&type=template&id=26d3d4d7&scoped=true&", function () {
      api.rerender('26d3d4d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/CustomerCards.vue"
export default component.exports